/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentBillItem
 */
export interface PaymentBillItem {
    /**
     * 账单ID
     * @type {number}
     * @memberof PaymentBillItem
     */
    id?: number;
    /**
     * 账单类型
     * @type {number}
     * @memberof PaymentBillItem
     */
    billType?: number;
    /**
     * 账单编号
     * @type {string}
     * @memberof PaymentBillItem
     */
    billCode?: string;
    /**
     * 账单名
     * @type {string}
     * @memberof PaymentBillItem
     */
    name?: string;
    /**
     * 账单状态
     * @type {number}
     * @memberof PaymentBillItem
     */
    status?: number;
    /**
     * 账单总金额（totalGoodsAmount+totalAdditionalServiceAmount+totalTransferAmount）
     * @type {number}
     * @memberof PaymentBillItem
     */
    totalAmount?: number;
}

/**
 * Check if a given object implements the PaymentBillItem interface.
 */
export function instanceOfPaymentBillItem(value: object): value is PaymentBillItem {
    return true;
}

export function PaymentBillItemFromJSON(json: any): PaymentBillItem {
    return PaymentBillItemFromJSONTyped(json, false);
}

export function PaymentBillItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentBillItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'billType': json['billType'] == null ? undefined : json['billType'],
        'billCode': json['billCode'] == null ? undefined : json['billCode'],
        'name': json['name'] == null ? undefined : json['name'],
        'status': json['status'] == null ? undefined : json['status'],
        'totalAmount': json['totalAmount'] == null ? undefined : json['totalAmount'],
    };
}

export function PaymentBillItemToJSON(json: any): PaymentBillItem {
    return PaymentBillItemToJSONTyped(json, false);
}

export function PaymentBillItemToJSONTyped(value?: PaymentBillItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'billType': value['billType'],
        'billCode': value['billCode'],
        'name': value['name'],
        'status': value['status'],
        'totalAmount': value['totalAmount'],
    };
}

